import { Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import * as ROUTES from "../../constants/routes";

const PermissionDenied = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "60vh" }}
      >
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} container justify="center">
            <Typography variant="h4">{t("permissionDenied")}</Typography>
          </Grid>
          <Grid item xs={12} container justify="center">
            <Link to={ROUTES.HOME}>
              <Typography variant="h5">{t("permissionDeniedHome")}</Typography>
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PermissionDenied;
